module.exports = __webpack_public_path__ + "static/img/5.1d77320.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fg/5.png
// module id = 134
// module chunks = 2